export const getScaleTypeById = ({ scales_types }) => (id) => {
  return scales_types.find((type) => type.id == id)
}

export const getEmployeeScalesById = ({ employees_scales }) => (id) => {
  return employees_scales.filter((employee_scale) => employee_scale.employee_id == id)
}

export const getEmployeeScalesByIdScale = ({ employees_scales }) => (id) => {
  return employees_scales.filter((employee_scale) => employee_scale.scale_id == id)
}

export const getEmployeeScaleByIdAndScale = ({ employees_scales }) => (scale_id, employee_id) => {
  return employees_scales.find(
    (employee_scale) =>
      employee_scale.scale_id == scale_id && employee_scale.employee_id == employee_id
  )
}
export const getActiveScales = ({ scales }) => {
  return scales.filter((scale) => scale.status == 1 || scale.status == 3)
}

export const getScalesFinisheds = ({ scales }) => {
  return scales.filter((scale) => scale.status != 1)
}
